import React, { useContext } from "react";
import { VariantContextData } from "../variants/VariantBuilderContext";
import VariantBuilderSetting from "../variants/VariantBuilderSetting";
import VariantBuilderPanelCollapse from "../variants/VariantBuilderPanelCollapse";

const VariantSettingsThemeTabs = (props) => {
  const [contextData] = useContext(VariantContextData);
  let variant = contextData.objects.variant;

  return (
    <React.Fragment>
      <VariantBuilderPanelCollapse name="Tabs" open={false}>
        <VariantBuilderSetting
          object={variant}
          label="Layout"
          setting_name="[options][tabs-layout]"
          setting_type="layout"
          object_type="variants"
          value={
            variant.options["tabs-layout"]
              ? variant.options["tabs-layout"]
              : "horizontal"
          }
          valueMappings={{
            responsive: 'horizontal',
            stacked: 'vertical',
          }}
          device="desktop"
        />

        <VariantBuilderSetting
          object={variant}
          label="Layout"
          setting_name="[options][tabs-layout-mobile]"
          setting_type="layout"
          object_type="variants"
          value={variant.options["tabs-layout-mobile"]}
          valueMappings={{
            responsive: 'horizontal',
            stacked: 'vertical',
          }}
          device="mobile"
        />

        <VariantBuilderSetting
          object={variant}
          label="Tabs Alignment"
          setting_name="[options][tabs-alignment]"
          setting_type="dropdown"
          object_type="variants"
          value={
            variant.options["tabs-alignment"]
              ? variant.options["tabs-alignment"]
              : "start"
          }
          options={[
            { value: "start", text: "Together (left)" },
            { value: "center", text: "Together (center)" },
            { value: "end", text: "Together (right)" },
            { value: "space-between", text: "Spaced (fill)" },
            { value: "space-evenly", text: "Spaced (even)" },
          ]}
          condition={variant.options["tabs-layout"] !== "vertical"}
        />

        <VariantBuilderSetting
          object={variant}
          label="Tabs Width"
          setting_name="[options][tabs-width]"
          setting_type="range"
          object_type="variants"
          value={
            variant.options["tabs-width"]
              ? variant.options["tabs-width"]
              : undefined
          }
          placeholder="0px"
          min={0}
          max={700}
          range_step={1}
          allow_empty={true}
          device="desktop"
          show_reset={true}
        />

        <VariantBuilderSetting
          object={variant}
          label="Tabs Width"
          setting_name="[options][tabs-width-mobile]"
          setting_type="range"
          object_type="variants"
          value={
            variant.options["tabs-width-mobile"]
              ? variant.options["tabs-width-mobile"]
              : undefined
          }
          placeholder={variant.options["tabs-width-mobile"] || "0px"}
          min={0}
          max={700}
          range_step={1}
          allow_empty={true}
          device="mobile"
          show_reset={true}
        />

        <VariantBuilderSetting
          object={variant}
          label="Tabs Border Style"
          setting_name="[options][tabs-border-style]"
          setting_type="border_style"
          object_type="variants"
          value={
            variant.options["tabs-border-style"]
              ? variant.options["tabs-border-style"]
              : undefined
          }
          show_reset={true}
        />

        <VariantBuilderSetting
          object={variant}
          label="Tabs Border Color"
          setting_name="[options][tabs-border-color]"
          setting_type="color_v2"
          object_type="variants"
          value={
            variant.options["tabs-border-color"]
              ? variant.options["tabs-border-color"]
              : undefined
          }
          placeholder="#000"
          condition={["dotted", "dashed", "solid"].includes(
            variant.options["tabs-border-style"]
          )}
          show_reset={true}
        />

        <div className="row hard-center">
          <VariantBuilderSetting
            object={variant}
            label="Border Hover"
            setting_name="[options][tabs-border-color-hover]"
            setting_type="color_v2"
            object_type="variants"
            value={
              variant.options["tabs-border-color-hover"]
                ? variant.options["tabs-border-color-hover"]
                : undefined
            }
            placeholder={
              variant.options["tabs-border-color-hover"]
                ? variant.options["tabs-border-color-hover"]
                : "#000"
            }
            col="6"
            classNames="some-padding-right"
            condition={["dotted", "dashed", "solid"].includes(
              variant.options["tabs-border-style"]
            )}
            show_reset={true}
          />

          <VariantBuilderSetting
            object={variant}
            label="Border Active"
            setting_name="[options][tabs-border-color-active]"
            setting_type="color_v2"
            object_type="variants"
            value={
              variant.options["tabs-border-color-active"]
                ? variant.options["tabs-border-color-active"]
                : undefined
            }
            placeholder={
              variant.options["tabs-border-color-active"]
                ? variant.options["tabs-border-color-active"]
                : "#000"
            }
            col="6"
            classNames="some-padding-left"
            condition={["dotted", "dashed", "solid"].includes(
              variant.options["tabs-border-style"]
            )}
            show_reset={true}
            offset_left={true}
          />
        </div>

        {variant.options["tabs-border-style"] &&
          variant.options["tabs-border-style"] !== "none" && (
            <div
              className="col-xs-12 some-vertical-space setting"
              style={{ marginBottom: "5px" }}
            >
              <div className="row">
                <div className="col-xs-12">
                  <div className="mb-[5px] text-xl text-black dark:text-white">Tabs Border Width</div>

                  {["left", "top", "bottom", "right"].map((side) => {
                    const settingName = `[options][tabs-border-width-${side}]`;
                    return (
                      <VariantBuilderSetting
                        key={settingName}
                        object={variant}
                        setting_name={settingName}
                        setting_type="number"
                        object_type="variants"
                        value={
                          _.isNil(
                            variant.options[`tabs-border-width-${side}`]
                          ) == false
                            ? variant.options[`tabs-border-width-${side}`]
                            : variant.options["tabs-border-width"]
                            ? variant.options["tabs-border-width"].replace(
                                "px",
                                ""
                              )
                            : "1"
                        }
                        placeholder="0px"
                        col="3"
                        note={window.capitalizeFirstLetter(side)}
                        classNames="spacing-inputs"
                        min={0}
                      />
                    );
                  })}
                </div>
              </div>
            </div>
          )}

        <VariantBuilderSetting
          object={variant}
          label="Tabs Corner Radius"
          setting_name="[options][tabs-radius]"
          setting_type="border_radius"
          valueMappings={{
            none: 'cf-not-rounded',
            some: 'cf-slightly-rounded',
            full: 'cf-fully-rounded',
            custom: 'custom',
          }}
          object_type="variants"
          value={
            variant.options["tabs-radius"]
              ? variant.options["tabs-radius"]
              : "cf-not-rounded"
          }
        />

        {variant.options["tabs-radius"] == "custom" && (
          <div className="col-xs-12">
            {["top-left", "top-right", "bottom-right", "bottom-left"].map(
              (side) => {
                const settingName = `[options][tabs-radius-${side}]`;
                return (
                  <VariantBuilderSetting
                    key={settingName}
                    object={variant}
                    setting_name={settingName}
                    setting_type="number"
                    object_type="variants"
                    value={
                      _.isNil(variant.options[`tabs-radius-${side}`]) == false
                        ? variant.options[`tabs-radius-${side}`]
                        : "3"
                    }
                    min={0}
                    note={capitalizeFirstLetter(side).replace("-", " ")}
                    col="3"
                    placeholder="0px"
                    classNames="spacing-inputs"
                  />
                );
              }
            )}
          </div>
        )}

        <VariantBuilderSetting
          object={variant}
          label="Tabs Padding Style"
          setting_name="[options][tabs-padding-style]"
          setting_type="dropdown"
          object_type="variants"
          value={
            variant.options["tabs-padding-style"]
              ? variant.options["tabs-padding-style"]
              : undefined
          }
          options={[
            { value: "", text: "Auto" },
            { value: "custom", text: "Custom" },
          ]}
          device="desktop"
        />

        <VariantBuilderSetting
          object={variant}
          label="Tabs Padding Value"
          setting_name="[options][tabs-padding-value]"
          setting_type="range"
          object_type="variants"
          value={
            variant.options["tabs-padding-value"]
              ? variant.options["tabs-padding-value"]
              : undefined
          }
          placeholder="15px"
          min={0}
          max={100}
          range_step={1}
          device="desktop"
          allow_empty={true}
          condition={variant.options["tabs-padding-style"] == "custom"}
          show_reset={true}
        />

        <VariantBuilderSetting
          object={variant}
          label="Tabs Padding Style"
          setting_name="[options][tabs-padding-style-mobile]"
          setting_type="dropdown"
          object_type="variants"
          value={
            variant.options["tabs-padding-style-mobile"]
              ? variant.options["tabs-padding-style-mobile"]
              : undefined
          }
          options={[
            { value: "", text: "Auto" },
            { value: "custom", text: "Custom" },
          ]}
          device="mobile"
          show_reset={true}
        />

        <VariantBuilderSetting
          object={variant}
          label="Tabs Padding Value"
          setting_name="[options][tabs-padding-value-mobile]"
          setting_type="range"
          object_type="variants"
          value={
            variant.options["tabs-padding-value-mobile"]
              ? variant.options["tabs-padding-value-mobile"]
              : undefined
          }
          placeholder="15px"
          min={0}
          max={100}
          range_step={1}
          device="mobile"
          allow_empty={true}
          condition={variant.options["tabs-padding-style-mobile"] == "custom"}
          show_reset={true}
        />

        <VariantBuilderSetting
          object={variant}
          label="Tabs Background Color"
          setting_name="[options][tabs-background-color]"
          setting_type="color_v2"
          object_type="variants"
          value={
            variant.options["tabs-background-color"]
              ? variant.options["tabs-background-color"]
              : undefined
          }
          placeholder={
            variant.options["tabs-background-color"]
              ? variant.options["tabs-background-color"]
              : ""
          }
          show_reset={true}
          gradient={true}
        />

        <div className="row hard-center">
          <VariantBuilderSetting
            object={variant}
            label="Backgr. Hover"
            setting_name="[options][tabs-background-color-hover]"
            setting_type="color_v2"
            object_type="variants"
            value={
              variant.options["tabs-background-color-hover"]
                ? variant.options["tabs-background-color-hover"]
                : undefined
            }
            placeholder={
              variant.options["tabs-background-color-hover"]
                ? variant.options["tabs-background-color-hover"]
                : ""
            }
            col="6"
            classNames="some-padding-right"
            show_reset={true}
            gradient={true}
          />

          <VariantBuilderSetting
            object={variant}
            label="Backgr. Active"
            setting_name="[options][tabs-background-color-active]"
            setting_type="color_v2"
            object_type="variants"
            value={
              variant.options["tabs-background-color-active"]
                ? variant.options["tabs-background-color-active"]
                : undefined
            }
            placeholder={
              variant.options["tabs-background-color-active"]
                ? variant.options["tabs-background-color-active"]
                : ""
            }
            col="6"
            classNames="some-padding-left"
            show_reset={true}
            gradient={true}
            offset_left={true}
          />
        </div>

        <VariantBuilderSetting
          object={variant}
          setting_name="[options][tabs-font-family]"
          label={"Title Font Family"}
          setting_type="select"
          object_type="variants"
          value={
            variant.options["tabs-font-family"]
              ? variant.options["tabs-font-family"]
              : undefined
          }
          option_groups={["System fonts", "Google fonts"]}
          options={[
            { value: "", text: "Default" },
            ...window.builder_fonts_dropdown,
          ]}
          col="8"
          callback={(new_value, old_value) => {
            ctas.builder.fonts.load_font_family(new_value);
          }}
          show_reset={true}
        />

        <VariantBuilderSetting
          object={variant}
          setting_name="[options][tabs-font-weight]"
          setting_type="font_weight"
          label="Weight"
          object_type="variants"
          value={
            variant.options["tabs-font-weight"]
              ? variant.options["tabs-font-weight"]
              : undefined
          }
          col="4"
          classNames="no-padding-left"
          show_reset={true}
        />

        <VariantBuilderSetting
          object={variant}
          label="Title Font Size"
          setting_name="[options][tabs-font-size]"
          setting_type="range"
          object_type="variants"
          value={
            variant.options["tabs-font-size"]
              ? variant.options["tabs-font-size"]
              : 16
          }
          min={0}
          max={100}
          range_step={1}
          device="desktop"
          allow_empty={true}
          show_reset={true}
        />

        <VariantBuilderSetting
          object={variant}
          label="Title Font Size"
          setting_name="[options][tabs-font-size-mobile]"
          setting_type="range"
          object_type="variants"
          value={
            variant.options["tabs-font-size-mobile"]
              ? variant.options["tabs-font-size-mobile"]
              : undefined
          }
          placeholder={variant.options["tabs-font-size"]
          ? variant.options["tabs-font-size"]
          : 16}
          min={0}
          max={100}
          range_step={1}
          device="mobile"
          allow_empty={true}
          show_reset={true}
        />

        <VariantBuilderSetting
          object={variant}
          label="Title Color"
          setting_name="[options][tabs-font-color]"
          setting_type="color_v2"
          object_type="variants"
          value={
            variant.options["tabs-font-color"]
              ? variant.options["tabs-font-color"]
              : undefined
          }
          placeholder={
            variant.options["tabs-font-color"]
              ? variant.options["tabs-font-color"]
              : "#000"
          }
          show_reset={true}
        />

        <div className="row hard-center">
          <VariantBuilderSetting
            object={variant}
            label="Title Hover"
            setting_name="[options][tabs-font-color-hover]"
            setting_type="color_v2"
            object_type="variants"
            value={
              variant.options["tabs-font-color-hover"]
                ? variant.options["tabs-font-color-hover"]
                : undefined
            }
            placeholder={
              variant.options["tabs-font-color-hover"]
                ? variant.options["tabs-font-color-hover"]
                : "#1e90ff"
            }
            col="6"
            classNames="some-padding-right"
            show_reset={true}
          />

          <VariantBuilderSetting
            object={variant}
            label="Title Active"
            setting_name="[options][tabs-font-color-active]"
            setting_type="color_v2"
            object_type="variants"
            value={
              variant.options["tabs-font-color-active"]
                ? variant.options["tabs-font-color-active"]
                : undefined
            }
            placeholder={
              variant.options["tabs-font-color-active"]
                ? variant.options["tabs-font-color-active"]
                : "#1e90ff"
            }
            col="6"
            classNames="some-padding-left"
            show_reset={true}
            offset_left={true}
          />
        </div>

        <VariantBuilderSetting
          object={variant}
          label="Tabs Content Spacing"
          setting_name="[options][tabs-content-spacing-horizontal]"
          setting_type="range"
          object_type="variants"
          value={
            variant.options["tabs-content-spacing-horizontal"]
              ? variant.options["tabs-content-spacing-horizontal"]
              : undefined
          }
          placeholder="0px"
          min={0}
          max={100}
          range_step={1}
          allow_empty={true}
          condition={variant.options["tabs-layout"] == "horizontal"}
          device="desktop"
          show_reset={true}
        />

        <VariantBuilderSetting
          object={variant}
          label="Tabs Content Spacing"
          setting_name="[options][tabs-content-spacing-vertical]"
          setting_type="range"
          object_type="variants"
          value={
            variant.options["tabs-content-spacing-vertical"]
              ? variant.options["tabs-content-spacing-vertical"]
              : undefined
          }
          placeholder="0px"
          min={0}
          max={100}
          range_step={1}
          allow_empty={true}
          condition={variant.options["tabs-layout"] == "vertical"}
          device="desktop"
          show_reset={true}
        />

        <VariantBuilderSetting
          object={variant}
          label="Tabs Content Spacing"
          setting_name="[options][tabs-content-spacing-horizontal-mobile]"
          setting_type="range"
          object_type="variants"
          value={
            variant.options["tabs-content-spacing-horizontal-mobile"]
              ? variant.options["tabs-content-spacing-horizontal-mobile"]
              : undefined
          }
          placeholder="0px"
          min={0}
          max={100}
          range_step={1}
          allow_empty={true}
          condition={variant.options["tabs-layout"] == "horizontal"}
          device="mobile"
          show_reset={true}
        />

        <VariantBuilderSetting
          object={variant}
          label="Tabs Content Spacing"
          setting_name="[options][tabs-content-spacing-vertical-mobile]"
          setting_type="range"
          object_type="variants"
          value={
            variant.options["tabs-content-spacing-vertical-mobile"]
              ? variant.options["tabs-content-spacing-vertical-mobile"]
              : undefined
          }
          placeholder="0px"
          min={0}
          max={100}
          range_step={1}
          allow_empty={true}
          condition={variant.options["tabs-layout"] == "vertical"}
          device="mobile"
          show_reset={true}
        />

        <VariantBuilderSetting
          object={variant}
          label="Content Background Color"
          setting_name="[options][tabs-content-background-color]"
          setting_type="color_v2"
          object_type="variants"
          value={
            variant.options["tabs-content-background-color"]
              ? variant.options["tabs-content-background-color"]
              : undefined
          }
          placeholder="#F5F5F5"
          gradient={true}
        />

        <VariantBuilderSetting
          object={variant}
          label="Content Border Style"
          setting_name="[options][tabs-content-border-style]"
          setting_type="border_style"
          object_type="variants"
          value={
            variant.options["tabs-content-border-style"]
              ? variant.options["tabs-content-border-style"]
              : undefined
          }
          show_reset={true}
        />

        <VariantBuilderSetting
          object={variant}
          label="Content Border Color"
          setting_name="[options][tabs-content-border-color]"
          setting_type="color_v2"
          object_type="variants"
          value={
            variant.options["tabs-content-border-color"]
              ? variant.options["tabs-content-border-color"]
              : undefined
          }
          placeholder="#000"
          condition={["dotted", "dashed", "solid"].includes(
            variant.options["tabs-content-border-style"]
          )}
          show_reset={true}
        />

        {variant.options["tabs-content-border-style"] &&
          variant.options["tabs-content-border-style"] !== "none" && (
            <div
              className="col-xs-12 some-vertical-space setting"
              style={{ marginBottom: "5px" }}
            >
              <div className="row">
                <div className="col-xs-12">
                  <div className="mb-[5px] text-xl text-black dark:text-white">Content Border Width</div>

                  {["left", "top", "bottom", "right"].map((side) => {
                    const settingName = `[options][tabs-content-border-width-${side}]`;
                    return (
                      <VariantBuilderSetting
                        key={settingName}
                        object={variant}
                        setting_name={settingName}
                        setting_type="number"
                        object_type="variants"
                        value={
                          _.isNil(
                            variant.options[`tabs-content-border-width-${side}`]
                          ) == false
                            ? variant.options[
                                `tabs-content-border-width-${side}`
                              ]
                            : variant.options["tabs-content-border-width"]
                            ? variant.options[
                                "tabs-content-border-width"
                              ].replace("px", "")
                            : "1"
                        }
                        placeholder="0px"
                        col="3"
                        note={window.capitalizeFirstLetter(side)}
                        classNames="spacing-inputs"
                        min={0}
                      />
                    );
                  })}
                </div>
              </div>
            </div>
          )}

        <VariantBuilderSetting
          object={variant}
          label="Content Corner Radius"
          setting_name="[options][tabs-content-radius]"
          setting_type="border_radius"
          valueMappings={{
            none: 'cf-not-rounded',
            some: 'cf-slightly-rounded',
            full: 'cf-fully-rounded',
            custom: 'custom',
          }}
          object_type="variants"
          value={
            variant.options["tabs-content-radius"]
              ? variant.options["tabs-content-radius"]
              : "cf-not-rounded"
          }
        />

        {variant.options["tabs-content-radius"] == "custom" && (
          <div className="col-xs-12">
            {["top-left", "top-right", "bottom-right", "bottom-left"].map(
              (side) => {
                const settingName = `[options][tabs-content-radius-${side}]`;
                return (
                  <VariantBuilderSetting
                    key={settingName}
                    object={variant}
                    setting_name={settingName}
                    setting_type="number"
                    object_type="variants"
                    value={
                      _.isNil(variant.options[`tabs-content-radius-${side}`]) ==
                      false
                        ? variant.options[`tabs-content-radius-${side}`]
                        : undefined
                    }
                    min={0}
                    note={capitalizeFirstLetter(side).replace("-", " ")}
                    col="3"
                    placeholder={
                      variant.options[`tabs-content-radius-${side}`]
                        ? variant.options[`tabs-content-radius-${side}`]
                        : "0px"
                    }
                    classNames="spacing-inputs"
                  />
                );
              }
            )}
          </div>
        )}
      </VariantBuilderPanelCollapse>
    </React.Fragment>
  );
};

export default VariantSettingsThemeTabs;
